import { render } from "./BlogRightSidebarTwo.vue?vue&type=template&id=c05e302e"
import script from "./BlogRightSidebarTwo.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebarTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__